import { useState } from "react";
import WidgetPanel from "./WidgetPanel";
import DashboardGrid from "./DashboardGrid";

export default function ViewingView() {
  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 flex flex-col min-h-0">
        {/* Dashboard Content */}
        <div className="flex-1 overflow-auto">
          <DashboardGrid />
        </div>
      </div>
    </div>
  );
}
